import { CSSProperties } from "react";

export const cardContainer: CSSProperties = {
  position: "relative",
  borderRadius: 8,
  background: "white",
  boxShadow: `rgba(0, 0, 0, .12) 0 0 2px 0, rgba(0, 0, 0, .24) 0 2px 2px 0`,
  backgroundColor: "white",
  transition: "margin-top .4s ease-in-out, transform .6s ease-in-out",
  overflow: "hidden",
};

export const cardContainerRemoving: CSSProperties = {
  ...cardContainer,
  zIndex: 100,
  marginTop: 0,
  transform: "translate3d(0, -1400px, 10px)",
};
